import { rootUrl } from '@navigation/routes';
import { getWirkUrl } from '@definitions/wirk-urls';

export const oidcAuthority = `${getWirkUrl('IdentityServer')}`;
export const oidcClientId = 'manager';
export const oidcRedirectUri = `${window.location.origin}/${rootUrl.navigate()}`;
//dynamic tenant name passed in the url
export const acrValues = `tenant:${rootUrl.navigate()}`;
